module.exports = __webpack_public_path__ + "static/img/xe_rz.d090a59.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xe_rz.png
// module id = FNOH
// module chunks = 0